import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map, isEqual } from "lodash";
import { normalizeAmount, formatData } from "../../../utils/transformer.util";
import { Button, Input, Select } from "../../../components/base/index";
import { MATA_PELAJARAN_LIST_TABLE_FIELDS } from "../../../constants/kurikulum/kurikulum.constant";

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class NilaiRaportEdit extends PureComponent {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickNext = this._onClickNext.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._setForm = this._setForm.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    const { user } = this.props;
    const { organizations_id } = user;

    this.state = {
      page: 1,
      selected: {},
      content: initialContent,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          organizations_id,
          listraport: [
            {
              score: "",
              subject_id: "",
              descriptions: "",
            },
          ],
          ekskul: [
            {
              id: "",
              name: "",
              grades: "",
            },
          ],
        },
        error: {
          listraport: "",
          ekskul: "",
        },
      },
      param: {},
    };
  }

  componentDidMount() {
    const { location, getLevels, getclassrooms, user } = this.props;
    const { state = {} } = location;
    const { organizations_id, school_unit } = user;
    const { isEdit = false, data } = state;
    const { content } = this.state;
    const { id } = state.data || "";
    const paramTypes = ["classrooms", "levels"];
    paramTypes.forEach((type) => {
      this._getParamOptionsAcademics(type);
    });
    console.log(content.list);
    // if (isEdit) {
    if (isEdit && id) {
      this._setForm(id, data);
    } else if (isEmpty(content.list)) {
      this._onSearchContent({ page: 1 }, id, data);
    }
    // this._setForm(date, period, classrooms_id);

    // }

    // this._getStudentOptions();
    // this._getFolderOptions();

    // this._getclassrooms();
    // getclassrooms();
    // getLevels();
    // if (id) {
    //   this.setState({id:id})
    //   this._handleLoadData(id)
    // }

    this._getPeriodsOptions({ units_id: school_unit.id });
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { id } = state.data || "";
    //  console.log(state)
    if ((!isEdit || !id) && !isEqual(prevProps, this.props)) {
      this._onSearchContent({ page: 1 });
    }
  }

  async _onSearchContent(params = {}, id, data) {
    const { filters, form } = this.state;
    const { value } = form;
    const { subject_id } = value;
    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          const { handleListRaportSubject, user } = this.props;
          const { organizations_id, school_unit } = user;
          const { units_id } = school_unit;

          // if (id) {
          // const payload_classes = await handleGetRaportSiswa({ id, organizations_id: organizations_id, units_id, classrooms_id: data.classrooms_id });
          const result = await handleListRaportSubject({
            id,
            organizations_id,
            classes_id: data.classes_id,
          });
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listraport: result,
              },
            },
          }));
          // this.setState({
          //   form: {
          //     value: {
          //       id: payload.id,
          //       students_id: payload.students_id,
          //       classrooms_id: data.classrooms_id,
          //       semester: payload.semester,
          //       classes_id: payload.classes_id,
          //       organizations_id: organizations_id,
          //       period: payload.period,
          //       average_value: payload.average_value,
          //       listraport: map(payload.listraport, (detail) => ({
          //         subject_id: detail.subject_id,
          //         name: detail.name,
          //         kkm: detail.kkm,
          //         score: detail.score,
          //         descriptions: detail.descriptions,
          //       })),
          //     },
          //     error: {
          //       listraport: [],
          //     },
          //   },
          // });
          // }
        } catch (err) {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listraport: [],
              },
            },
          }));
        }
      },
    );
  }

  _onChangeListAmount(event) {
    const { keywords } = this.state;
    this.setState({
      listAmount: Number(event.target.value),
    });
    this._onSearchContent({ limit: event.target.value, keywords, page: 1 });
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
      () => this._onSearchContent(),
    );
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id } = user;
    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    console.log(res);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async onEdit() {
    const { history, handleEditLembarObsHarian } = this.props;
    const { form } = this.state;
    const { value } = form;
    const canSaveA = false;
    const canSaveB = false;
    const dataTabel = value.pelajaran;
    const dataForm = form.value;
    let a;
    await handleEditLembarObsHarian(value);
    history.push(
      "/dashboard/kurikulum/ulangan/pengisian-lembar-observasi-harian",
    );
    // }
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions } = this.props;
    const res = await getPeriodsOptions(filters);
    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              period: data.value,
            },
          },
        }));
      }
    });
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  async _setForm(id, data) {
    const { handleGetRaportSiswa, user } = this.props;
    const { organizations_id, school_unit } = user;

    console.log(data);
    try {
      const payload = await handleGetRaportSiswa({
        id,
        organizations_id,
        classes_id: data.classes_id,
        period: data.periods_id,
        units_id: school_unit.id,
      });
      console.log(payload.ekskul);

      this.setState({
        form: {
          value: {
            id: payload.id,
            students_id: payload.students_id,
            classrooms_id: data.classrooms_id,
            semester: payload.semester,
            organizations_id,
            period: payload.period,
            average_value: payload.average_value,
            sick: payload.sick,
            permission : payload.permission,
            alpha : payload.alpha,
            personality : payload.personality,
            morals : payload.morals,
            listraport: map(payload.listraport, (detail) => ({
              subject_id: detail.subject_id,
              name: detail.name,
              kkm: detail.kkm,
              score: detail.score,
              descriptions: detail.descriptions,
            })),
            ekskul: map(payload.ekskul, (detail_2) => ({
              id: detail_2.ekskul_id,
              name: detail_2.name,
              grades: detail_2.grades,
              description: detail_2.description,
            })),
          },
          error: {
            listraport: [],
          },
        },
      });
    } catch (err) {
      // err action
    }
  }

  async onSubmit() {
    const { history, handleSaveRaportSiswa } = this.props;
    const { form } = this.state;
    const { value } = form;
    const canSaveA = false;
    const dataForm = form.value;
    console.log(value);
    await handleSaveRaportSiswa(value);
    history.push("/dashboard/kurikulum/raport/daftar-nilai-raport");
    // history.go(0);
  }

  _onFormChange(event) {
    const { user } = this.props;
    const { organizations_id } = user;
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked ? value : "";
          }
          newList = prevState.form.value[fieldName];
          newListError = prevState.form.error[fieldName] || [];
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        if (name === "levels_id") {
          this._getParamOptionsAcademics("classrooms", {
            levels_id: value,
            organizations_id,
          });
        }

        // if (name === 'classes') {
        //   this._getStudentOptions({ filters: { classes_id: value.map(item => item.value)}} );
        // }
      },
    );
  }

  _onClickNext() {
    const { history } = this.props;
    history.push("/dashboard/kesiswaan/laporan/daftar-siswa-kelas-unit");
  }

  render() {
    const { location, getLevels, getclassrooms, user } = this.props;
    const { form, param } = this.state;
    const { state = {} } = location;
    const { listraport, ekskul } = form.value;
    const { isEdit = false, data } = state;
    const { id } = state.data || "";
    const semester_data = [
      { label: "Ganjil", value: "ganjil" },
      { label: "Genap", value: "genap" },
    ];
    form.value.period = data ? data.periods_id : form.value.period;
    form.value.semester = data.semester ? data.semester : form.value.semester;
    let rata2 = 0;
    let jml = 0;
    console.log(ekskul);
    const styles = {
      table: {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "14px",
      },
      th: {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "center",
        fontWeight: "bold",
      },
      td: {
        border: "1px solid #000",
        padding: "6px",
        verticalAlign: "middle",
      },
      tdCenter: {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "center",
      },
    };

    console.log(form.value)

    return (
      <div className="student-list">
        <div className="budget__title">
          <h1>Nilai Raport </h1>
          <hr />
        </div>
        <form onSubmit={this._onSubmit}>
          <div className="result__content">
            <div className="nilai-raport__custom-form-row">
              <div className="nilai-raport__custom-form-row__field">
                <p>Nama &emsp;: {data ? data.name : ""}</p>
              </div>
              <div className="nilai-raport__custom-form-column__field">
                <Select
                  label="Tahun Ajaran"
                  name="period"
                  onChange={this._onFormChange}
                  placeholder="Pilihan"
                  data={param.periods}
                  value={form.value.period}
                  error={form.error.period || ""}
                />
              </div>
            </div>
            <div className="nilai-raport__custom-form-row">
              <div className="nilai-raport__custom-form-row__field">
                <p>No VA &emsp;&emsp;: {data ? data.no_va : ""}</p>
              </div>
              <div className="nilai-raport__custom-form-column__field">
                <Select
                  name="semester"
                  label="Semester"
                  placeholder="Pilihan"
                  onChange={this._onFormChange}
                  data={semester_data}
                  value={form.value.semester}
                  error={form.error.semester || ""}
                />
              </div>
            </div>
            <div className="nilai-raport__custom-form-row">
              <div className="nilai-raport__custom-form-row__field">
                <p>Kelas &emsp;: {data ? data.classrooms_name : ""}</p>
              </div>
              <div className="nilai-raport__custom-form-column__field" />
            </div>
          </div>
          <br />
          <br />

          <div className="manage-registration">
            <div className="fund-request__content">
              <table className="table">
                <thead>
                  <tr>
                    {map(
                      MATA_PELAJARAN_LIST_TABLE_FIELDS.label,
                      (field, idx) => (
                        <th key={`table_th_${idx}`}>{field}</th>
                      ),
                    )}
                  </tr>
                </thead>
                <tbody>
                  {map(listraport, (list, idx) => (
                    <tr key={`budget_row_${idx}`}>
                      {(() => {
                        // form.value.average_value
                        jml += Number(list.score);
                        console.log(list.score);
                        console.log(list.length);
                        // if (data.cicilan == "Cicilan 0") {
                        //   data.cicilan = "DP"
                        // }
                      })()}
                      {map(
                        MATA_PELAJARAN_LIST_TABLE_FIELDS.value,
                        (field, fieldIdx) => {
                          if (fieldIdx === 0) {
                            return (
                              <td
                                key={`table_index_${fieldIdx}_${idx}`}
                                style={{ textAlign: "center" }}
                              >
                                {idx + 1}
                              </td>
                            );
                          }

                          if (field.attribute === "score") {
                            return (
                              <td key={`table_${fieldIdx}_${idx}`}>
                                <Input
                                  type="number"
                                  name="score"
                                  data-input-array
                                  data-array-position={idx}
                                  data-field-name="listraport"
                                  onChange={this._onFormChange}
                                  value={list.score}
                                />{" "}
                              </td>
                              // {/* <Link to={'www.google.com'}>{data.hyperlink}</Link> </td> */}
                            );
                          }

                          if (field.attribute === "descriptions") {
                            return (
                              <td key={`table_${fieldIdx}_${idx}`}>
                                <Input
                                  type="text"
                                  name="descriptions"
                                  data-input-array
                                  data-array-position={idx}
                                  data-field-name="listraport"
                                  onChange={this._onFormChange}
                                  value={list.descriptions}
                                />{" "}
                              </td>
                              // {/* <Link to={'www.google.com'}>{data.hyperlink}</Link> </td> */}
                            );
                          }

                          return (
                            <td
                              className={
                                field.type === "number" ? "nominal" : ""
                              }
                              key={`table_${fieldIdx}_${idx}`}
                            >
                              {formatData(list, field)}
                            </td>
                          );
                        },
                      )}
                      {/* {this._renderButtons(list)} */}
                    </tr>
                  ))}
                  {
                    <tr>
                      {console.log(listraport)}
                      {(() => {
                        // form.value.average_value
                        rata2 = jml / (listraport ? listraport.length : 0);
                        console.log(rata2);
                        form.value.average_value =
                          rata2 || form.value.average_value;
                        // if (data.cicilan == "Cicilan 0") {
                        //   data.cicilan = "DP"
                        // }
                      })()}
                      <td colSpan="3">Nilai Rata-Rata</td>
                      <td colSpan="2">
                        <Input
                          type="number"
                          name="average_value"
                          placeholder="Pilihan"
                          onChange={this._onFormChange}
                          value={form.value.average_value}
                          disabled
                        />
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <br />

              {/* ===== KEGIATAN PENGEMBANGAN DIRI ===== */}
              <table className="table">
                <thead>
                  <tr>
                    <th style={{width:"10%"}}>Kegiatan</th>
                    <th style={{width:"20%"}}>Jenis</th>
                    <th style={{width:"35%"}}>Nilai</th>
                    <th style={{width:"35%"}}>Keterangan</th>
                  </tr>
                </thead>
                <tbody>
                  {ekskul.map((item, idx) => (
                    <tr key={`ekskul_row_${idx}`}>
                      {/* TD EKSTRAKULIKULER – HANYA DI BARIS PERTAMA */}
                      {idx === 0 && (
                        <td rowSpan={ekskul.length} style={styles.td}>
                          Ekstrakulikuler
                        </td>
                      )}

                      <td style={styles.td}>{item.name}</td>

                      <td style={styles.td}>
                        <Input
                          type="number"
                          name="grades"
                          data-input-array
                          data-array-position={idx}
                          data-field-name="ekskul"
                          onChange={this._onFormChange}
                          value={item.grades}
                        />
                      </td>

                      <td style={styles.td}>
                        <Input
                          type="text"
                          name="description"
                          data-input-array
                          data-array-position={idx}
                          data-field-name="ekskul"
                          onChange={this._onFormChange}
                          value={item.description}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <br />

              {/* ===== BAGIAN BAWAH (2 KOLOM) ===== */}
              <div style={{ display: "flex", gap: "30px" }}>
                {/* AKHLAK & KEPRIBADIAN */}
                <div style={{ width: "50%" }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th colSpan="3" style={styles.th}>
                          AKHLAK KEPRIBADIAN
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{width: "40%"}}>Akhlak</td>
                        <td style={styles.tdCenter}>:</td>
                        <td style={{width: "40%"}}> <Input
                          type="text"
                          name="morals"
                          onChange={this._onFormChange}
                          value={form.value.morals}
                        /></td>
                      </tr>
                      <tr>
                        <td style={{width: "40%"}}>Kepribadian</td>
                        <td style={styles.tdCenter}>:</td>
                        <td style={{width: "40%"}}>
                           <Input
                          type="text"
                          name="personality"
                          onChange={this._onFormChange}
                          value={form.value.personality}
                        />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* KETIDAKHADIRAN */}
                <div style={{ width: "50%" }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{width: "10%"}}>No.</th>
                        <th style={{width: "20%"}}>Jenis</th>
                        <th style={{width: "25%"}}>Jumlah Hari</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={styles.tdCenter}>1.</td>
                        <td style={styles.td}>Sakit</td>
                        <td style={styles.tdCenter}>
                           <Input
                          type="number"
                          name="sick"
                          onChange={this._onFormChange}
                          value={form.value.sick}
                        />
                        </td>
                      </tr>
                      <tr>
                        <td style={styles.tdCenter}>2.</td>
                        <td style={styles.td}>Ijin</td>
                        <td style={styles.tdCenter}>
                            <Input
                          type="number"
                          name="permission"
                          onChange={this._onFormChange}
                          value={form.value.permission}
                        />
                        </td>
                      </tr>
                      <tr>
                        <td style={styles.tdCenter}>3.</td>
                        <td style={styles.td}>Tanpa Keterangan</td>
                        <td style={styles.tdCenter}>
                            <Input
                          type="number"
                          name="alpha"
                          onChange={this._onFormChange}
                          value={form.value.alpha}
                        />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <br></br>
                </div>
              </div>
            </div>
          </div>

          <div className="manage-registration__footer">
            {this.state.id ? (
              <Button type="button" title="Update" onClick={this.onEdit} />
            ) : (
              <Button type="button" title="Simpan" onClick={this.onSubmit} />
            )}
          </div>
        </form>
      </div>
    );
  }
}
NilaiRaportEdit.propTypes = {
  handleGetKlapper: PropTypes.func,
  handleDeleteKlapper: PropTypes.func,
};
NilaiRaportEdit.defaultProps = {
  handleGetKlapper: noop,
  handleDeleteKlapper: noop,
};
